import { render } from "./ProsesPDOMonev.vue?vue&type=template&id=51233e1d"
import script from "./ProsesPDOMonev.vue?vue&type=script&lang=js"
export * from "./ProsesPDOMonev.vue?vue&type=script&lang=js"

import "./ProsesPDOMonev.vue?vue&type=style&index=0&id=51233e1d&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__